import React, { useEffect } from "react";

import Link from "@atoms/Link";

import { URLS } from "@const/urls";

export default function NotFound() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="pc:col-span-12 col-span-8 flex flex-col gap-1">
      <span>404 Page Not Found</span>
      <Link as="text" href={URLS.HOME}>
        Go to Home Page
      </Link>
    </section>
  );
}
